export function isPng(bytes: Uint8Array): boolean {
  return bytes.length >= 8 && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47;
}

export function isJpeg(bytes: Uint8Array): boolean {
  return bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff;
}

export async function webpToPngBytes(bytes: Uint8Array): Promise<Uint8Array> {
  const blob = new Blob([new Uint8Array(bytes)], { type: 'image/webp' });
  const bmp = await createImageBitmap(blob);
  const c = document.createElement('canvas');
  c.width = bmp.width;
  c.height = bmp.height;
  const ctx = c.getContext('2d');
  if (!ctx) throw new Error('Canvas unavailable');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(bmp, 0, 0);
  const pngBlob = await new Promise<Blob>((res, rej) => {
    c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob failed'))), 'image/png');
  });
  return new Uint8Array(await pngBlob.arrayBuffer());
}
